/* eslint-disable import/prefer-default-export -- utility used via named import */
import type { DataProvider } from '../types/types';

/**
 * Page size for preview / data-provider POST payloads (HTTP pagination, SavOQ, or SQL default).
 */
export function getDataProviderPreviewPageSize(
  dataProvider: DataProvider
): number {
  if (dataProvider.type === 'HTTP') {
    return dataProvider.httpApi.pagination?.pageSize ?? 10;
  }

  if (dataProvider.type === 'DATASTORE') {
    return dataProvider.pageSize ?? 10;
  }

  return 10;
}
